import { RouteRecordRaw } from 'vue-router'

import { REPORT_ROUTE_NAMES } from '@/modules/report/constants/ReportRouteNames'
import ReportLayout from '@/modules/report/layouts/ReportLayout.vue'
import ReportsPerformances from '@/modules/report/pages/ReportsPerformances.vue'

import { UserGroup } from '@generated/types'

export const reportRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/reports',
    component: ReportLayout,
    redirect: { name: REPORT_ROUTE_NAMES.SALES_SUMMARY },
    meta: { usesCustomNavbar: true },
    children: [
      {
        path: 'sales-summary',
        name: REPORT_ROUTE_NAMES.SALES_SUMMARY,
        component: () => import('@/modules/report/pages/ReportSalesSummary.vue'),
        meta: {
          pageTitle: 'Sales Summary',
        },
      },
      {
        path: 'overview',
        redirect: { name: REPORT_ROUTE_NAMES.PERFORMANCES },
      },
      {
        path: 'performances',
        name: REPORT_ROUTE_NAMES.PERFORMANCES,
        component: ReportsPerformances,
        meta: {
          pageTitle: 'Performances',
        },
      },
      {
        path: 'downloads',
        name: REPORT_ROUTE_NAMES.DOWNLOADS,
        component: () => import('@/modules/report/pages/ReportDownloads.vue'),
        meta: {
          pageTitle: 'Report Downloads',
        },
      },
      {
        path: 'analytics',
        name: REPORT_ROUTE_NAMES.WEB_ANALYTICS,
        component: () => import('@/modules/mailchimp/pages/MarketingAnalytics.vue'),
        props: { hideMessage: true },
        meta: {
          pageTitle: 'Web Analytics',
          requiresAuth: UserGroup.OWNERS,
        },
      },
      {
        path: 'show-insights',
        name: REPORT_ROUTE_NAMES.SHOW_INSIGHTS,
        component: () => import('@/modules/show/pages/ShowInsights.vue'),
        meta: {
          pageTitle: 'Show Insights',
        },
      },
    ],
  },
]
